export default {
  'menu.package-management': '套餐管理',
  'menu.package-management.local': '本地版套餐',
  'menu.package-management.cloud': '云端版套餐',
  'menu.package-management.cloud.pipe': '管道套餐管理',
  'menu.package-management.cloud.algo-fee': '算法计费管理',
  'menu.package-management.cloud.storage': '存储服务管理',
  'menu.package-management.cloud.extra': '扩展服务定价',
  'menu.trade-finance': '交易与财务',
  'menu.trade-finance.order': '订单管理',
  'menu.trade-finance.daily-settlement': '日结算账单',
  'menu.trade-finance.arrears': '欠费管控',
  'menu.device-quota': '设备额度管理',
  'menu.order-management': '订单管理',
  'menu.real-time-monitor': '实时监控',
  'menu.algorithm-management': '算法管理',
  'menu.algorithm-management.train': '算法训练',
  'menu.user-management': '用户管理',
  'menu.open-cert-audit': '开发者资质审核',
  'menu.open-package-settings': '开发者套餐设置',
  'menu.open-package-orders': '开发者订购记录',
  'menu.train-config': '算法模型自定义训练参数',
  'menu.client-app-version': '客户端版本更新',
  'menu.client-app-version.local': '本地版版本更新',
  'menu.client-app-version.cloud': '云端版版本更新',
  'menu.client-app-version.android': '安卓版版本更新',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
